import { useMutation } from "@tanstack/react-query";
import { updateGoogleBusinessProfileContactLocation } from "../../api/bReviewsApi";

export const useUpdateGoogleBusinessProfileContactLocation = () => {
  return useMutation({
    mutationFn: ({ locationId, data }) =>
      updateGoogleBusinessProfileContactLocation(locationId, data),
  });
};
